import { useQuery } from '@apollo/client';

import { getFragment } from '../graphql/client/helpers/get-fragment';
import { GetMedicationDocument } from '../graphql/generated/graphql';

export const useMedication = (ndc: string | undefined) => {
    const { called, data, loading } = useQuery(GetMedicationDocument, {
        variables: { id: ndc! },
        skip: !ndc,
    });

    const medication = getFragment(data?.medication);

    return {
        called,
        loading,
        medication,
    };
};
